import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ClipLoader } from 'react-spinners';
import { useAlert } from 'context/AlertContext';

import { forgotPassword } from '../../redux/actions/auth';
import { BackButton, LoginField, Foot } from 'components/LoginModal/parts';

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { showAlert } = useAlert();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await dispatch(forgotPassword(email));
      showAlert({
        type: 'success',
        title: t('alert_dialog.forgot_password.success_title'),
        message: t('alert_dialog.forgot_password.success_message'),
        primaryAction: { label: t('common.ok') },
      });
    } catch (err) {
      showAlert({
        type: 'error',
        title: t('alert_dialog.forgot_password.reset_link_error_title'),
        message: t('alert_dialog.forgot_password.reset_link_error_message'),
        primaryAction: { label: t('common.ok') },
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="px-6 sm:px-9 pt-9 pb-0">
        <BackButton label={t('login.back_to_login')} onClick={onBack} />
        <div className="font-display text-[11px] font-bold uppercase tracking-[0.14em] text-yellow-04">
          {t('login.reset_password_eyebrow', 'Reset password')}
        </div>
        <h2 className="font-serif font-normal text-[30px] sm:text-[36px] leading-[1.05] tracking-[-0.01em] text-ink mt-2 mb-0">
          {t('login.reset_password_title_a', 'Forgot your')}{' '}
          <em className="italic">
            {t('login.reset_password_title_b', 'password')}
          </em>
          ?
        </h2>
        <p className="mt-2.5 text-[14px] leading-[1.5] text-muted-2">
          {t(
            'login.reset_password_sub',
            "Type the email tied to your account — we'll send a link to set a new password. The link is valid for 30 minutes."
          )}
        </p>
      </div>

      <form className="px-6 sm:px-9 pt-6 pb-7 flex flex-col gap-4" onSubmit={handleSubmit}>
        <LoginField
          label={t('login.email')}
          type="email"
          value={email}
          onChange={setEmail}
          placeholder="you@example.com"
          autoComplete="email"
        />
        <button
          type="submit"
          disabled={!email || isSubmitting}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full
                     bg-ink text-white border border-ink px-5 py-4 text-[15px] font-semibold
                     hover:bg-black disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <ClipLoader color="#FFFFFF" size={18} />
          ) : (
            t('login.send_link')
          )}
        </button>
      </form>

      <Foot>
        <span>{t('login.remembered', 'Remembered it?')}</span>
        <button
          type="button"
          onClick={onBack}
          className="font-bold text-ink underline underline-offset-[3px] hover:text-yellow-04"
        >
          {t('login.back_to_login')}
        </button>
      </Foot>
    </>
  );
};

export default ForgotPassword;
